import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';

interface ConfirmExitDialogProps {
  open: boolean;
  onClose: () => void;
  onExit: () => void;
}


const ConfirmExitDialog: React.FC<ConfirmExitDialogProps> = ({ open, onClose, onExit }) => {
  const { t } = useTranslation('enrollment');
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('Clear Data')}</DialogTitle>
      <DialogContent>
        {t('Are you sure you would like to clear the registration data?')}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onClose} color="primary" style={{ width: 'unset' }}>
          {t('Cancel')}
        </Button>
        <Button variant="outlined" onClick={onExit} color="error" style={{ width: 'unset' }} autoFocus>
          {t('Clear Data')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmExitDialog;
